import { Dispatch } from '@reduxjs/toolkit';

import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { CasesTableView, TableView, TableViewStatus } from 'dashboard/models/table-view';
import { setCurrentTableViewId, setTableViews } from 'dashboard/redux/slices/table-views';
import Action from 'lib/interfaces/Action';
import { ApiEndpoint } from 'lib/interfaces/api';

export function loadTableViews({
  filters: { tableKey, status },
  sortParams,
}: {
  filters: { tableKey: string; status?: TableViewStatus[] };
  sortParams?: SortParams;
}) {
  return async (dispatch: Dispatch) => {
    const tableViews = await SessionClientDashboard.listResource<CasesTableView>(
      ApiEndpoint.TableView,
      {
        filter: {
          'table-key': tableKey,
          status,
        },
        ...(sortParams && {
          sort: `${sortParams.shouldSortDescending ? '-' : ''}${sortParams.sort}`,
        }),
      },
    );

    dispatch(setTableViews({ tableViews: tableViews.data }));
    if (tableViews.data.length > 0) {
      dispatch(setCurrentTableViewId({ currentTableViewId: tableViews.data[0].id }));
    }
  };
}

/**
 * For non-Cases implementations
 */
export function loadGenericTableViews<TV extends TableView<any>>({
  filters: { tableKey, status },
  sortParams,
  setTableViews,
  setCurrentTableView,
}: {
  filters: { tableKey: string; status?: TableViewStatus[] };
  sortParams?: SortParams;
  setTableViews: (tableViews: TV[]) => Action<string, TV[]>;
  setCurrentTableView: (currentTableView: string) => Action<string, string>;
}) {
  return async (dispatch: Dispatch) => {
    const tableViews = await SessionClientDashboard.listResource<TV>(ApiEndpoint.TableView, {
      filter: {
        'table-key': tableKey,
        status,
      },
      ...(sortParams && {
        sort: `${sortParams.shouldSortDescending ? '-' : ''}${sortParams.sort}`,
      }),
    });

    dispatch(setTableViews(tableViews.data));
    if (tableViews.data.length > 0) {
      dispatch(setCurrentTableView(tableViews.data[0].id));
    }
  };
}
